<template>

  <v-container fluid class="trip-wizard checkout-container" :pa-0="$vuetify.breakpoint.xsOnly">
    
    <review-dialog 
      v-if="needsToReview" 
      :open="showReviewDialog" 
      @on-close="showReviewDialog = false" 
      @on-review-complete="$emit('reload')"
      :trip-id="selections.id" 
    ></review-dialog>

    <v-dialog
      v-model="outOfStockDialog"
      max-width="700"
      transition="fade"
      :persistent="outOfStockItems.length > 0"
    >
      <v-card color="white">
        <v-card-title class="primary white--text text-xs-center">Items No Longer Available</v-card-title>
        <v-card-text>
          <v-layout row wrap justify-center>
            <v-flex xs12 class="text-xs-center error--text title mt-3">
              {{ (outOfStockItems.length == 1 ? 'This' : 'These') }} item{{ (outOfStockItems.length == 1 ? '' : 's') }} in your order {{ (outOfStockItems.length == 1 ? 'is' : 'are') }} no longer available
            </v-flex>
            <v-flex xs12>
              <v-data-iterator
                :items="outOfStockItems"
                hide-actions
                content-tag="v-layout"
                content-class="wrap justify-center"
              >
                <template v-slot:item="props">
                  <v-flex
                    xs6
                    md3
                    lg2
                  >
                    <inventory-item :item="props.item" condensed ignore-availability />
                  </v-flex>
                </template>
              </v-data-iterator>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-text class="text-xs-center">
          <v-btn color="primary white--text" @click="outOfStockReview">Review Selections</v-btn>
        </v-card-text>
        <v-card-actions class="primary white--text">
          <v-spacer></v-spacer>
          
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="checkoutDialog"
      max-width="800"
      scrollable
      transition="fade"
      :persistent="ordering"
    >
      <v-card color="white">
        
        <v-card-title class="primary white--text text-xs-center" style="position: relative;">
          <v-btn
            absolute
            small
            fab
            top
            right
            flat
            color="white"
            style="top: 10px;"
            :disabled="ordering"
            @click="checkoutDialog = false"
          ><v-icon>fas fa-times</v-icon></v-btn>
          <h3 style="margin: 0 auto;">Checkout</h3>
        </v-card-title>
        <v-card-text v-if="loadingIntent || loadingCards">
          <div class="spinner">
            <div class="double-bounce1"></div>
            <div class="double-bounce2"></div>
          </div>
        </v-card-text>
        <v-card-text v-else class="pa-0">
          <v-layout row wrap>
            <v-flex sm6 class="grey lighten-4 pa-3">
              <h3>Summary</h3>
              <table class="checkout-summary-table mt-3">
                <tr>
                  <td><strong>Clothes</strong></td>
                  <td><strong>${{ order.subtotal | currency }}</strong></td>
                </tr>
                <tr>
                  <td>Personal Styling</td>
                  <td>FREE</td>
                </tr>
                <tr>
                  <td>Cleaning</td>
                  <td>FREE</td>
                </tr>
                <tr>
                  <td>Shipping</td>
                  <td>FREE</td>
                </tr>
                <tr>
                  <td>Tax</td>
                  <td>$0</td>
                </tr>
              </table>
              <table class="checkout-summary-table mt-4">
                <tr v-if="coupon">
                  <td class="green--text text--darken-1">
                    <div class="green--text text--darken-1"><span><b>PROMO CODE {{ order.coupon.code }}</b></span></div>
                    <div class="grey--text text--darken-1 mt-1" v-html="couponDescription"></div> 
                  </td>
                  <td class="green--text text--darken-1 negative-before" style="vertical-align: top;">${{ order.discount | currency }}</td>
                </tr>
                <tr>
                  <td><h3>Total</h3></td>
                  <td>
                    <h3>${{ order.total | currency }}</h3>
                  </td>
                </tr>
              </table>
              <v-layout column>
                <v-flex v-if="order.total < 50" class="text-xs-center mt-4 sub-title">
                  <span><strong>Your card will <span class="error--text text--darken-2">NOT</span> be charged unless items are not returned, or come back damaged</strong></span>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex sm6 class="pa-3">
              <v-layout row wrap>
                <v-flex v-if="cards && cards.length && !newCard" class="text-xs-center">
                  Select your payment method
                  <v-container fluid grid-list-md px-0>
                    <v-layout row wrap justify-center>
                      <v-flex
                        v-for="card in cards"
                        :key="card.stripe_id"
                        xs12
                      >
                        <v-hover>
                          <v-layout 
                            slot-scope="{ hover }"
                            row 
                            class="pa-2 ma-0"
                            align-center
                            :class="{'elevation-3':hover,'elevation-1':!hover,'primary white--text':(card.stripe_id == cardSelected),'grey lighten-3':(card.stripe_id != cardSelected)}"
                            style="cursor: pointer;"
                            @click="cardSelected = card.stripe_id"
                          >
                            <v-flex class="text-xs-left">
                              <i class="fab fa-cc-visa fa-3x" v-if="card.type == 'visa'" />
                              <i class="fab fa-cc-amex fa-3x" v-if="card.type == 'amex'" />
                              <i class="fab fa-cc-diners-club fa-3x" v-if="card.type == 'diners'" />
                              <i class="fab fa-cc-mastercard fa-3x" v-if="card.type == 'mastercard'" />
                              <i class="fab fa-cc-discover fa-3x" v-if="card.type == 'discover'" />
                              <i class="fab fa-cc-jcb fa-3x" v-if="card.type == 'jcb'" />
                            </v-flex>
                            <v-flex class="text-xs-right"> 
                              <div style="font-size: 1.1em;"><b>{{ card.name }}</b></div>
                              <div style="font-size: .8em;">XXXX-{{ card.last4 }}</div>
                            </v-flex>
                          </v-layout>
                        </v-hover>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-flex>
                <v-flex :class="{'d-none': (!newCard && cards && cards.length)}">
                  <h3>Billing Address</h3>
                  <v-container grid-list-md class="pa-0 ma-0">
                    <v-layout row wrap class="mt-3">
                      <v-flex xs12>
                        <div class="field-label">Name on Card</div>
                        <v-text-field
                          flat
                          solo
                          hide-details
                          class="pt-0"
                          v-model="billing_details.name"
                          :disabled="ordering"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <div class="field-label">Street</div>
                        <v-text-field
                          flat
                          solo
                          hide-details
                          class="pt-0"
                          v-model="billing_details.street"
                          :disabled="ordering"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs6>
                        <div class="field-label">City</div>
                        <v-text-field
                          flat
                          solo
                          hide-details
                          class="pt-0"
                          v-model="billing_details.city"
                          :disabled="ordering"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs3>
                        <div class="field-label">State</div>
                        <v-text-field
                          flat
                          solo
                          hide-details
                          class="pt-0"
                          v-model="billing_details.state"
                          :disabled="ordering"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs3>
                        <div class="field-label">Zip</div>
                        <v-text-field
                          flat
                          solo
                          hide-details
                          class="pt-0"
                          v-model="billing_details.postal"
                          :disabled="ordering"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <div class="field-label">Country</div>
                        <country-select
                          :prefill="billing_details.country"
                          @on-change="updateCountry"
                          :disabled="ordering"
                        ></country-select>
                        
                      </v-flex>
                    </v-layout>
                  </v-container>
                  <h3 class="mt-4">Card Information</h3>
                  <v-container grid-list-md class="pa-0 ma-0">
                    <v-layout row class="mt-2">
                      <v-flex>
                        <!--<stripe
                          ref="stripe"
                          @on-change="stripeChange"
                          @on-error="processNewStripeError"
                          @on-token="processNewStripeToken"
                        ></stripe>-->
                        <stripe
                          ref="stripe"
                          :billing-details="billing_details"
                          @on-change="stripeChange"
                          @on-intent-complete="processStripeIntentComplete"
                          @on-intent-error="processStripeIntentError"
                          @on-setup-intent-complete="processStripeSetupIntentComplete"
                          @on-setup-intent-error="processStripeSetupIntentError"
                        ></stripe>
                      </v-flex>
                    </v-layout>
                  </v-container>
                  
                </v-flex>
              </v-layout>
              <div class="text-xs-center">
                <v-btn color="primary" :disabled="checkoutConfirmDisabled" @click="processOrder" :loading="ordering">
                  ORDER
                </v-btn>
              </div>
              <div class="text-xs-center mt-2" v-if="cards && cards.length && !newCard">
                <a class="grey--text text--darken-2 caption" @click="newCard = true">ADD A CARD</a>
              </div>
              <div class="text-xs-center mt-2" v-else-if="cards && cards.length">
                <a class="grey--text text--darken-2 caption" @click="newCard = false">CHOOSE EXISTING CARD</a>
              </div>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions class="primary white--text">
          <v-spacer></v-spacer>
          
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <transition name="fade-up" mode="out-in" appear>
      
      <v-layout justify-center wrap v-if="order.status=='PENDING'" key="checkout-pending">

        <v-flex class="pb-0" style="max-width: 900px;">
          <v-layout row>
            <v-flex xs12 class="text-xs-center">
              <h1>You're almost packed!</h1>
              <h1>Please review your suitcase before you go.</h1>
            </v-flex>
          </v-layout>
          
          <v-layout row wrap v-if="invalidSelections.length" justify-center>
            <v-flex xs12 class="text-xs-center error--text title mt-3">
              {{ (invalidSelections.length == 1 ? 'This' : 'These') }} item{{ (invalidSelections.length == 1 ? '' : 's') }} in your suitcase {{ (invalidSelections.length == 1 ? 'is' : 'are') }} no longer available and {{ (invalidSelections.length == 1 ? 'is' : 'are') }} not included in the total
            </v-flex>
            <v-flex xs12>
              <v-data-iterator
                :items="invalidSelections"
                hide-actions
                content-tag="v-layout"
                content-class="wrap justify-center"
              >
                <template v-slot:item="props">
                  <v-flex
                    xs6
                    md3
                    lg2
                  >
                    <inventory-item :item="props.item" condensed ignore-availability />
                  </v-flex>
                </template>
              </v-data-iterator>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex md6 class="pa-4 mt-5">

          <v-layout row wrap style="border: 1px solid #000;" class="ma-0 pa-0">
            <v-flex v-if="validSelections.length">
              <v-data-iterator
                :items="validSelections"
                hide-actions
                content-tag="v-layout"
                content-class="wrap"
              >
                <template v-slot:item="props">
                  <v-flex
                    xs6
                  >
                    <inventory-item :item="props.item" />
                  </v-flex>
                </template>
              </v-data-iterator>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex class="text-xs-center">
              <a @click="previousStep()" style="text-decoration: underline; font-size: 1.2em;">View My Options</a>
            </v-flex>
          </v-layout>

        </v-flex>
        

        <v-flex md6 class="pa-4 mt-5">

          <v-layout column style="border: 1px solid #000;" class="ma-0 pa-3">
            <v-flex class="py-2" :class="{'px-1':$vuetify.breakpoint.xsOnly, 'px-4':$vuetify.breakpoint.smAndUp}">
              <h3>Summary</h3>
              <table class="checkout-summary-table mt-3">
                <tr>
                  <td><strong>Clothes</strong></td>
                  <td><strong>${{ order.subtotal | currency }}</strong></td>
                </tr>
                <tr>
                  <td>Personal Styling</td>
                  <td>FREE</td>
                </tr>
                <tr>
                  <td>Cleaning</td>
                  <td>FREE</td>
                </tr>
                <tr>
                  <td>Shipping</td>
                  <td>FREE</td>
                </tr>
                <tr>
                  <td>Tax</td>
                  <td>$0</td>
                </tr>
              </table>
            </v-flex>
            <v-divider></v-divider> 
            <v-flex class="py-2" :class="{'px-1':$vuetify.breakpoint.xsOnly, 'px-4':$vuetify.breakpoint.smAndUp}">
              <table class="checkout-summary-table">
                <tr v-if="order.coupon">
                  <td class="green--text text--darken-1">
                    <div class="green--text text--darken-1"><span class="mr-2"><b>PROMO CODE {{ order.coupon.code }}</b></span><a class="caption ml-2 grey--text" @click="removeCoupon()">REMOVE</a></div>
                    <div class="grey--text text--darken-1 mt-1" v-html="couponDescription"></div> 
                  </td>
                  <td class="green--text text--darken-1 negative-before" style="vertical-align: top;">${{ order.discount | currency }}</td>
                </tr>
                <tr>
                  <td><strong>Total</strong>
                  <td>
                    <strong v-if="order.total < 50">FREE</strong>
                    <strong v-else>${{ order.total | currency }}</strong>
                  </td>
                </tr>
              </table>

              <v-layout row px-0 py-3 v-if="!coupon">
                <v-flex>
                  <v-text-field
                    v-model="couponCode"
                    hide-details
                    solo
                    flat
                    label="Coupon Code"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex class="text-xs-right">
                  <v-btn color="primary" @click="applyCoupon()" :loading="couponLoading">Apply</v-btn>
                </v-flex>
              </v-layout>
            </v-flex>

            
          </v-layout>
          <v-btn large color="primary" block class="ma-0" @click="openCheckout()" :disabled="validSelections.length < 2">
            <span>PLACE MY ORDER</span>
          </v-btn>

        </v-flex>

      </v-layout>

      <v-layout justify-center wrap v-else key="checkout-complete">

        <v-flex xs12 class="pb-0" style="max-width: 900px;">
          <v-layout row>
            <v-flex xs12 class="text-xs-center">
              <h1 v-if="order.status == 'PROCESSING'">Your order is being processed</h1>
              <span v-else-if="order.status == 'COMPLETE'">
                <h1 v-if="tripStatus == 'before'">Your bags are packed!</h1>
                <h1 v-if="tripStatus == 'current'">Your current trip order</h1>
                <h1 v-if="tripStatus == 'after'">Thank you for your order!</h1>
              </span>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12 class="text-xs-center" v-if="needsToReview">
              <v-btn color="primary" @click="showReviewDialog = true">Review your trip</v-btn>
            </v-flex>
            <v-flex xs12 class="text-xs-center mt-0" v-if="needsToReview">
              Your feedback will help improve your next experience
            </v-flex>
          </v-layout>
          
        </v-flex>

        <v-flex xs12 class="pb-0 mt-5">

          <v-layout row wrap justify-center align-center>
            <v-flex xs12 md10 pa-0 ma-0 style="border: 2px solid #000">
              <v-layout row justify-center align-center my-3>
                <v-flex shrink style="min-height: 25px;" class="pt-2 pb-0">
                  <div class="text-xs-center"><strong>Order #{{ order.id }}</strong></div>
                  <div class="text-xs-center mt-1" v-if="tripStatus == 'before'">
                    <span>{{ order.total_items }} items<span v-if="order.status == 'COMPLETE'"> will arrive by {{ $moment(selections.address.date_start).subtract(1,'day').format("L") }}</span></span>
                    <div v-if="order.tracking_number && order.tracking_url" class="text-center mt-1">
                      <v-btn target="_blank" color="primary" small :href="order.tracking_url">Track Your Order</v-btn>
                    </div>
                  </div>
                </v-flex>
              </v-layout>
              <v-layout row justify-center ma-0>
                <v-flex xs12 px-5 pb-5 pt-2 my-4>
                  <v-container grid-list-md pa-0 ma-0>
                    <v-layout row wrap>
                       <v-flex
                        v-for="inv in selected"
                        :key="'complete-invid-' + inv.id"
                        xs6
                        sm4
                        md3
                      >
                        <inventory-item :item="inv" ignore-availability />
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-flex>
              </v-layout>
            </v-flex>

            <!--<v-flex xs12 md10 pa-0 mx-0 my-4>
              <table cellspacing="0px" class="order-details-table">
                <thead>
                  <tr>
                    <th>Order Date</th>
                    <th>Payment Method</th>
                    <th>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      {{ $moment.unix(order.created_at).format("L") }}
                    </td>
                    <td>{{ order.card_type }} XXXX-{{ order.card_last4 }}</td>
                    <td>${{ order.total | currency }}</td>
                  </tr>
                </tbody>
              </table>
            </v-flex>-->
          </v-layout>
          
          
        </v-flex>

        <v-flex xs12 class="text-xs-center mt-4">
          <div class="mb-3 text-xs-center"><v-btn large color="primary" :to="{name: 'trip', params: {id: 'new'}}">BOOK ANOTHER TRIP</v-btn></div> 
          <div class="my-1 text-xs-center"><router-link :to="{name: 'account-trips'}" style="text-decoration: none;">View my account</router-link></div>
        </v-flex>

      </v-layout>

      
    </transition>
  </v-container>

</template>

<script>
import InventoryItem from '@/components/helpers/InventoryItem';
import Stripe from '@/components/helpers/Stripe';
import CountrySelect from '@/components/helpers/CountrySelect';
import ReviewDialog from '@/components/helpers/ReviewDialog';

export default {
  props: {
    selections: Object
  },
  components: {
    'inventory-item': InventoryItem,
    'stripe': Stripe,
    'country-select': CountrySelect,
    'review-dialog': ReviewDialog
  },
  name: 'Checkout',
  data () {
    return {
      checkoutDialog: false,
      stripeComplete: false,
      outOfStockDialog: false,
      outOfStockVariationIds: [],
      ordering: false,
      couponLoading: false,
      couponCode: null,

      loadingIntent: false,
      intent: null,
      loadingCards: false,
      cards: null,
      cardSelected: null,
      newCard: false,


      billing_details: {
        name: this.$store.getters.user.first_name + ' ' + this.$store.getters.user.last_name,
        street: this.$store.getters.user.address_line_1,
        city: this.$store.getters.user.address_city,
        state: this.$store.getters.user.address_state,
        postal: this.$store.getters.user.address_postal,
        country: this.$store.getters.user.address_country
      },

      showReviewDialog: false

    }
  },
  mounted: function() {
    this.toggleWizardNextPrev();
    if(this.needsToReview && this.$route.query.review == 1) {
      this.showReviewDialog = true;
      this.$router.replace({query: null});
    }
  },
  watch: {
    
  },
  computed: {
    cdn: function() {
      return this.$root.cdn;
    },
    user: function() {
      return this.$store.getters.user;
    },
    nextDisabled: function() {
      return false;
    },
    previousDisabled: function() {
      return false;
    },
    order: function() {
      return this.selections.order;
    },
    checkoutConfirmDisabled: function() {
      if(this.cards && this.cards.length && !this.newCard && this.cardSelected) {
        return false;
      } else {
        if(!this.billing_details.street || !this.billing_details.city || !this.billing_details.state || !this.billing_details.postal || !this.billing_details.country) return true;
        if(!this.stripeComplete) return true;
      }
      return false;
    },
    coupon: function() {
      return this.order.coupon;
    },
    couponDescription: function() {
      if(!this.order.coupon) return '';
      let res = '';
      if(this.order.coupon.type == 'PERCENTAGE') res += 'Up To ' + this.order.coupon.amount + '% Off';
      if(this.order.coupon.type == 'PERCENTAGE' && this.order.coupon.max_amount) res += '';
      if(this.order.coupon.type == 'AMOUNT') res += '$' + (this.order.coupon.amount / 100) + ' Off';
      return res;
    },

    inventory: function() {
      let arr = [];
      for(let i = 0; i < this.order.orderInventory.length; i++) {
        let inv_id = this.order.orderInventory[i].inventory_id;
        let sel_id = this.order.orderInventory[i].variation_id;
        for(let i2 = 0; i2 < this.order.inventory.length; i2++) {
          let inv = JSON.parse(JSON.stringify(this.order.inventory[i2]));
          if(this.order.inventory[i2].id == inv_id) {
            inv.recommended = sel_id;
            inv.selected = sel_id;
            arr.push(inv);
          }
        }
      }
      return arr;
    },
    selected: function() {
      let items = [];
      for(let i = 0; i < this.inventory.length; i++) {
        if(this.inventory[i].selected) items.push(this.inventory[i]);
      }
      return items;
    },
    invalidSelections: function() {
      let items = [];
      for(let i = 0; i < this.selected.length; i++) {
        let item = this.selected[i];
        let selid = item.selected;
        for(let i2 = 0; i2 < item.variations.length; i2++) {
          if(item.variations[i2].id == selid) {
            if(!item.variations[i2].available || item.variations[i2].stock_quantity <= 0) items.push(item);
            break;
          }
        }
      }
      return items;
    },
    validSelections: function() {
      let items = [];
      for(let i = 0; i < this.selected.length; i++) {
        let item = this.selected[i];
        let selid = item.selected;
        for(let i2 = 0; i2 < item.variations.length; i2++) {
          if(item.variations[i2].id == selid) {
            if(item.variations[i2].available && item.variations[i2].stock_quantity > 0) items.push(item);
            break;
          }
        }
      }
      return items;
    },

    outOfStockItems: function() {
      let items = [];
      for(let vi = 0; vi < this.outOfStockVariationIds.length; vi++) {
        let variation_id = this.outOfStockVariationIds[vi];

        for(let i = 0; i < this.selected.length; i++) {
          let item = this.selected[i];
          for(let i2 = 0; i2 < item.variations.length; i2++) {
            if(item.variations[i2].id == variation_id) {
              items.push(item);
              break;
            }
          }
        }
      }
      return items;
    },

    tripStatus: function() {
      let today = this.$moment();
      let checkin = this.$moment(this.selections.address.date_start);
      let checkout = this.$moment(this.selections.address.date_end);
      if(today.isBefore(checkin, 'day')) return 'before';
      if(today.isAfter(checkout, 'day')) return 'after';
      return 'current';
    },
    needsToReview: function() {
      if(!this.selections.review_id) return true;
      return false;
    }
  },
  methods: {
    toggleWizardNextPrev: function() {
      this.$store.commit('setWizardNextDisabled', this.nextDisabled);
      this.$store.commit('setWizardPrevDisabled', this.previousDisabled);
    },

    nextStep: function() {
      if(!this.nextDisabled) {
        
      }
    },
    previousStep: function() {
      if(!this.previousDisabled) {
        let ref = this;
        ref.$emit('on-cancel');
      }
    },

    stripeChange: function(e) {
      this.stripeComplete = (e.complete ? true : false);
    },

    updateCountry: function(val) {
      this.$set(this.billing_details, 'country', val);
    },

    processOrder: function() {
      this.ordering = true;
      let ref = this;
      let ids_to_validate = [];
      for(let i = 0; i < this.validSelections.length; i++) {
        ids_to_validate.push(this.validSelections[i].selected);
      }

      this.$http.post('orders/' + this.order.id + '/validate-stock',{
        'variation_ids': ids_to_validate
      })
        .then(stockResponse => {
          let out_of_stock_ids = stockResponse.data.variation_ids_out_of_stock;
          if(out_of_stock_ids.length) {
            this.ordering = false;
            this.outOfStockVariationIds = out_of_stock_ids;
            this.outOfStockDialog = true;
          } else {

            if(this.order.total < 50) {
              //this.loadingIntent = true;
              this.$http.get('users/' + this.user.id + '/add-intent')
                .then(response => {
                  this.intent = response.data;
                  this.$refs.stripe.setupIntent(this.intent.client_secret);
                })
                .catch(error => {
                  this.intent = null;
                  this.$swal.fire('Error', 'There was an issue saving the card form from loading. Please try again');
                  this.checkoutDialog = false;
                })
                .finally(() => {
                  //this.loadingIntent = false;
                })
              
            } else {
              if(this.cards && this.cards.length && this.cardSelected && !this.newCard) {
                this.$refs.stripe.confirmIntent(this.intent.client_secret, this.cardSelected);
              } else {
                this.$refs.stripe.confirmIntent(this.intent.client_secret);
              }
            }
          }
        })
        .catch(stockError => {
          this.ordering = false;
          this.$swal.fire('Order Error', stockError.response.data.message);
        })
        .finally( () => {

        });
    },
    processStripeIntentComplete(e) {
      //console.log('PROCESS STRIPE INTENT COMPLETE', e);
      let status = 'PROCESSING';
      if(e === 'FREE' || e.paymentIntent.status == 'succeeded') status = 'COMPLETE';
      let params = {
        status: status
      };

      //if(this.cards && this.cards.length &&)
      this.$http.put('orders/' + this.order.id + '?expand=orderInventory,inventory,inventory.variations,coupon', params)
        .then(response => {
          this.submitSupplierOrder(this.order.id);
          this.$emit('on-update', response.data);
          this.checkoutDialog = false;
        })
        .catch(error => {
          this.$swal.fire('Payment Delay', 'There is a delay in processing your payment. If you don\'t receive an order confirmation email or text in the next 5 minutes please contact support.')
          this.$router.push({name: 'account'});
        })
        .finally(() => {
          this.ordering = false;
        });
    },
    processStripeIntentError(e) {
      this.$swal.fire('Payment Error', e.error.message);
      this.ordering = false;
    },
    
    processStripeSetupIntentComplete(e) {
      //Update user billing information
      let params = {
        payment_method: e.setupIntent.payment_method
      }

      this.$http.post('users/' + this.user.id + '/payment-method', params)
        .then(response => {
          //this.cards.push(response.data);
          this.processStripeIntentComplete('FREE');
        })
        .catch(error => {
          this.$swal.fire('Error', 'There was an error adding your card. Please try again.');
        })
        .finally(() => {
        });
      
    },
    processStripeSetupIntentError(e) {
      this.$swal.fire('Error Adding Card', e.error.message);
      this.ordering = false;
    },

    submitSupplierOrder: function(order_id) {
      this.$http.post('orders/' + order_id + '/create-order-on-supplier',{process: 1})
        .then(response => {})
        .catch(error => {
          console.log(error.response.data.message);
        })
        .finally(() => {});
    },

    /*preProcessOrder: function() {
      this.ordering = true;

      

      let data = {
        billing_address: this.billing_street,
        billing_city: this.billing_city,
        billing_state: this.billing_state,
        billing_postal: this.billing_postal,
        billing_country: this.billing_country
      }

      this.$http.patch('users/' + this.user._id, data)
        .then(response => {
          this.processNewStripeCardOrder();
        })
        .catch(error => {
          this.$swal.fire('Error', 'There was an error updating your billing address');
          this.ordering = false;
        })
    },*/

    
    processNewStripeCardOrder: function() {
      this.$refs.stripe.getToken();
    },
    processNewStripeToken: function(token) {
      let token_id = token.id;

      if(this.user.cc_brand) {

        this.$http.post('update-card', {
          user_id: this.user._id,
          cc_source: token_id
        }).then(response => {
          this.processExistingStripeCardOrder();
        }).catch(error => {
          this.$swal.fire('Error', 'There was an error updating your card');
          this.ordering = false;
        })

        return;
      }

      let data = {
        user_id: this.user._id,
        trip_id: this.selections._id,
        lookbook_id: this.selections.lookbook._id,
        items: this.selections.lookbook.user_selected,
        total_price: this.order.total,
        total_items: this.order.total_items,
        ord_type: 'rent',
        cc_source: token_id
      }
      
      if(this.coupon) data.discount_code = this.coupon.coupon_code;

      /*this.$http.post('charge', data)
        .then(response => {
          this.checkoutDialog = false;
          this.ordering = false;

          this.$http.patch('lookbooks/' + this.selections.lookbook._id, {order_id: response.data._id})
            .then(lbResponse => {

            })
            .catch(lbError => {
              this.$swal.fire('Error', 'Your card was charged but there was an error saving your order correctly. Please contact support.');
            })
          this.$http.get('users/' + this.user._id)
            .then(usResponse => {
              this.$store.commit('setUser', usResponse.data);
            })
            .catch(usError => {});
        })
        .catch(error => {
          this.$swal.fire('Error', 'There was an error processing your order');
          this.ordering = false;
        });*/
    },
    processNewStripeError: function(msg) {
      this.$swal.fire('Credit Card Error', msg);
      this.ordering = false;
    },

    processExistingStripeCardOrder: function() {
      let data = {
        user_id: this.user._id,
        trip_id: this.selections._id,
        lookbook_id: this.selections.lookbook._id,
        items: this.selections.lookbook.user_selected,
        total_price: this.order.subtotal,
        total_items: this.selections.lookbook.user_selected.length,
        ord_type: 'rent'
      }
      if(this.coupon) data.discount_code = this.coupon.coupon_code;

      /*this.$http.post('charge', data)
        .then(response => {
          this.completedOrder = response.data;
          this.checkoutDialog = false;
          this.ordering = false;

          this.$http.patch('lookbooks/' + this.selections.lookbook._id, {order_id: response.data._id})
            .then(lbResponse => {

            })
            .catch(lbError => {
              this.$swal.fire('Error', 'Your card was charged but there was an error saving your order correctly. Please contact support.');
            });

          this.$http.get('users/' + this.user._id)
            .then(usResponse => {
              this.$store.commit('setUser', usResponse.data);
            })
            .catch(usError => {});
        })
        .catch(error => {
          this.$swal.fire('Error', 'There was an error processing your order');
          this.ordering = false;
        });*/
    },

    applyCoupon: function() {
      if(!this.couponCode) {
        this.$swal.fire('Invalid Coupon', 'The coupon code you have entered is invalid');
        return;
      }
      let params = {
        coupon_code: this.couponCode.toUpperCase()
      }

      this.couponLoading = true;
      this.$http.put('orders/' + this.order.id + '?expand=orderInventory,inventory,inventory.variations,coupon', params)
        .then(response => {
          this.$emit('on-update', response.data);
        })
        .catch(error => {
          this.$swal.fire('Invalid Coupon', 'The coupon code you have entered is invalid');
        })
        .finally( () => {
          this.couponLoading = false;
        })
    },

    removeCoupon: function() {
      let params = {
        coupon_code: null
      };

      this.couponLoading = true;
      this.$http.put('orders/' + this.order.id + '?expand=orderInventory,inventory,inventory.variations,coupon', params)
        .then(response => {
          this.couponCode = null;
          this.$emit('on-update', response.data);
        })
        .catch(error => {
          this.$swal.fire('Error', 'There was a problem removing the coupon. Please try again.');
        })
        .finally( () => {
          this.couponLoading = false;
        });

    },

    openCheckout: function() {
      
      

      this.loadingIntent = true;
      this.checkoutDialog = true;
      this.newCard = false;
      this.cardSelected = null;
      this.loadingCards = true;
      
      //PROCESS FREE DIFFERENTLY
      if(this.order.total < 50) {
        //this.processStripeIntentComplete('FREE');
        this.loadingIntent = false;
        /*this.$http.get('users/' + this.user.id + '/add-intent')
          .then(response => {
            this.intent = response.data;
          })
          .catch(error => {
            this.intent = null;
            this.$swal.fire('Error', 'There was an issue preventing the card form from loading. Please try again');
            this.checkoutDialog = false;
          })
          .finally(() => {
            this.loadingIntent = false;
          })*/
        //return;
      } else {

      
        this.$http.get('orders/' + this.order.id + '/intent')
          .then(response => {
            this.intent = response.data
          })
          .catch(error => {
            this.$swal.fire('Error', 'There was an error preparing your order. If this problem continues please contact support.');
            this.checkoutDialog = false;
          })
          .finally(() => {
            this.loadingIntent = false;
          })
      }

      this.$http.get('users/' + this.user.id + '?fields=cards&expand=cards')
        .then(response => {
          if(this.order.total < 50 && response.data.cards.length) {
            this.processStripeIntentComplete('FREE');
          } else {
            this.cards = response.data.cards;
            this.loadingCards = false;
          }
        })
        .catch(error => {
          //Ignore card load errors
          this.loadingCards = false;
        })
        .finally(() => {
          //this.loadingCards = false;
        });
      
    },

    outOfStockReview: function() {
      this.outOfStockDialog = false;
      this.checkoutDialog = false;
      this.outOfStockVariationIds = [];
      this.$emit('reload');
    }
    
  }
}
</script>

<style lang="scss">
  
  .negative-before {
    position: relative;
    &:before {
      position: absolute;
      top: 3px;
      left: -8px;
      content: '-';
    }
  }

  .order-details-table {
    width: 100%;
    th,td {
      padding: 10px;
      text-align: center;
    }
    th {
      border: 2px solid #000;
      border-left-width: 0px;
      &:first-child {
        border-left-width: 2px;
      }
    }
    td {
      border-right: 2px solid #000;
      border-bottom: 2px solid #000;
      &:first-child {
        border-left: 2px solid #000;
      }
    }

  }
</style>